import { useEffect } from "react";

export default function Seo({ title, description }) {
  useEffect(() => {
    document.title = title ? `${title} | نموذج عقاري` : "نموذج عقاري | موقع وساطة عقارية تجريبي";
    if (description) {
      document.querySelector('meta[name="description"]')?.setAttribute("content", description);
    }
  }, [title, description]);
  return null;
}
